// These icons are sourced from open source projects.
//
// Fluent Icons by Microsoft (https://fluenticons.co/).
// - superscript.svg
// - subscript.svg
// - highlight.svg
// - highlight-accent.svg
// - background-color.svg
// - background-color-accent.svg
// - open.svg
// - table-merge.svg
// - table-split.svg
//
// Phosphor Icons (https://phosphoricons.com/).
// - other icons

// common
import plus from './plus.svg';
import question from './question.svg';
import more from './more.svg';
import left from './left.svg';
import right from './right.svg';
import down from './down.svg';
import check from './check.svg';
import checkCircle from './check-circle.svg';
import warningCircle from './warning-circle.svg';
import open from './open.svg';
import download from './download.svg';
import copy from './copy.svg';
import remove from './remove.svg';
import maximize from './maximize.svg';
import close from './close.svg';
import resize from './resize.svg';
import expand from './expand.svg';
import circleNotch from './circle-notch.svg';
// toolbar
import selectAll from './select-all.svg';
import undo from './undo.svg';
import redo from './redo.svg';
import heading from './heading.svg';
import heading1 from './heading1.svg';
import heading2 from './heading2.svg';
import heading3 from './heading3.svg';
import heading4 from './heading4.svg';
import heading5 from './heading5.svg';
import heading6 from './heading6.svg';
import paragraph from './paragraph.svg';
import blockQuote from './block-quote.svg';
import list from './list.svg';
import numberedList from './numbered-list.svg';
import bulletedList from './bulleted-list.svg';
import checklist from './checklist.svg';
import table from './table.svg';
import alignLeft from './align-left.svg';
import alignCenter from './align-center.svg';
import alignRight from './align-right.svg';
import alignJustify from './align-justify.svg';
import increaseIndent from './increase-indent.svg';
import decreaseIndent from './decrease-indent.svg';
import formatPainter from './format-painter.svg';
import bold from './bold.svg';
import italic from './italic.svg';
import underline from './underline.svg';
import strikethrough from './strikethrough.svg';
import superscript from './superscript.svg';
import subscript from './subscript.svg';
import code from './code.svg';
import removeFormat from './remove-format.svg';
import moreStyle from './more-style.svg';
import fontColor from './font-color.svg';
import fontColorAccent from './font-color-accent.svg';
import highlight from './highlight.svg';
import highlightAccent from './highlight-accent.svg';
import backgroundColor from './background-color.svg';
import backgroundColorAccent from './background-color-accent.svg';
import link from './link.svg';
import specialCharacter from './special-character.svg';
import hr from './hr.svg';
import image from './image.svg';
import media from './media.svg';
import attachment from './attachment.svg';
import codeBlock from './code-block.svg';
import emoji from './emoji.svg';
import equation from './equation.svg';
import video from './video.svg';
import twitter from './twitter.svg';
// table
import tableColumn from './table-column.svg';
import tableRow from './table-row.svg';
import tableMerge from './table-merge.svg';
import tableSplit from './table-split.svg';
// link
import unlink from './unlink.svg';
// image
import imageBroken from './image-broken.svg';
import zoomIn from './zoom-in.svg';
import zoomOut from './zoom-out.svg';
import caption from './caption.svg';
// file
import file from './file.svg';
// alert
import info from './info.svg';
import tip from './tip.svg';
import warning from './warning.svg';
import danger from './danger.svg';

export const icons = new Map<string, string>([
  // common
  ['plus', plus],
  ['question', question],
  ['more', more],
  ['left', left],
  ['right', right],
  ['down', down],
  ['check', check],
  ['checkCircle', checkCircle],
  ['warningCircle', warningCircle],
  ['open', open],
  ['download', download],
  ['copy', copy],
  ['remove', remove],
  ['maximize', maximize],
  ['close', close],
  ['resize', resize],
  ['expand', expand],
  ['circleNotch', circleNotch],
  // toolbar
  ['selectAll', selectAll],
  ['undo', undo],
  ['redo', redo],
  ['heading', heading],
  ['heading1', heading1],
  ['heading2', heading2],
  ['heading3', heading3],
  ['heading4', heading4],
  ['heading5', heading5],
  ['heading6', heading6],
  ['paragraph', paragraph],
  ['blockQuote', blockQuote],
  ['list', list],
  ['numberedList', numberedList],
  ['bulletedList', bulletedList],
  ['checklist', checklist],
  ['table', table],
  ['alignLeft', alignLeft],
  ['alignCenter', alignCenter],
  ['alignRight', alignRight],
  ['alignJustify', alignJustify],
  ['increaseIndent', increaseIndent],
  ['decreaseIndent', decreaseIndent],
  ['formatPainter', formatPainter],
  ['bold', bold],
  ['italic', italic],
  ['underline', underline],
  ['strikethrough', strikethrough],
  ['superscript', superscript],
  ['subscript', subscript],
  ['code', code],
  ['removeFormat', removeFormat],
  ['moreStyle', moreStyle],
  ['fontColor', fontColor],
  ['fontColorAccent', fontColorAccent],
  ['highlight', highlight],
  ['highlightAccent', highlightAccent],
  ['backgroundColor', backgroundColor],
  ['backgroundColorAccent', backgroundColorAccent],
  ['link', link],
  ['specialCharacter', specialCharacter],
  ['hr', hr],
  ['image', image],
  ['media', media],
  ['attachment', attachment],
  ['codeBlock', codeBlock],
  ['emoji', emoji],
  ['equation', equation],
  ['video', video],
  ['twitter', twitter],
  // table
  ['tableColumn', tableColumn],
  ['tableRow', tableRow],
  ['tableMerge', tableMerge],
  ['tableSplit', tableSplit],
  // link
  ['unlink', unlink],
  // image
  ['imageBroken', imageBroken],
  ['zoomIn', zoomIn],
  ['zoomOut', zoomOut],
  ['caption', caption],
  // file
  ['file', file],
  // alert
  ['info', info],
  ['tip', tip],
  ['warning', warning],
  ['danger', danger],
]);
